import get from 'lodash/get';
import { createSelector } from 'reselect';

export const selectThemeOptions = state => get(state, 'theme', {});
export const selectThemeOptionFromOptions = (themeOptions, key, defaultValue) => get(themeOptions, key, defaultValue);

export const makeSelectThemeOption = (key, defaultValue) => createSelector(
  selectThemeOptions, (themeOptions) => selectThemeOptionFromOptions(themeOptions, key, defaultValue)
);
